import { createUseStyles } from 'react-jss';

const phone = '@media (max-width: 480px)';

export const useStyles = createUseStyles({
  page: {
    minHeight: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    paddingTop: 'calc(32px + env(safe-area-inset-top, 0px))',
    paddingBottom: 'calc(32px + env(safe-area-inset-bottom, 0px))',
    background: '#f4f6f8',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: 420,
    padding: '32px 28px',
    [phone]: {
      padding: '24px 20px',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 8,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 24,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 8,
  },
});
